import { autoUpdate, flip, FloatingPortal, offset, shift, useFloating, useHover, useInteractions, type Placement } from '@floating-ui/react';
import { cloneElement, isValidElement, useState, type ReactElement, type Ref } from 'react';

export function Tooltip({ label, hint, placement = 'bottom', children }: { label: string; hint?: string; placement?: Placement; children: ReactElement }) {
  const [open, setOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({ open, onOpenChange: setOpen, placement, whileElementsMounted: autoUpdate, middleware: [offset(6), flip(), shift({ padding: 8 })] });
  const hover = useHover(context, { delay: { open: 500, close: 0 }, move: false });
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
  if (!isValidElement(children)) return children;
  const child = children as ReactElement<Record<string, unknown> & { ref?: Ref<Element> }>;
  return (
    <>
      {cloneElement(child, { ref: refs.setReference, ...getReferenceProps(child.props) })}
      {open && (
        <FloatingPortal>
          <div ref={refs.setFloating} className="lm-tooltip" style={floatingStyles} role="tooltip" {...getFloatingProps()}>
            {label}
            {hint && <span className="lm-tooltip-hint">{hint}</span>}
          </div>
        </FloatingPortal>
      )}
    </>
  );
}
